module.exports = __webpack_public_path__ + "static/media/f6.9a2f44bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/f6.jpg
// module id = 399
// module chunks = 0